import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { House, ArrowLeftRight, CalendarDays, UserRound, CircleHelp } from 'lucide-react';
import { primaryDestinations, destinationForPath } from '../navigation/productNavigation';
const icons = { overview: House, activity: ArrowLeftRight, plan: CalendarDays, account: UserRound };
export default function Navigation() {
  const location = useLocation();
  const active = destinationForPath(location.pathname);
  return <aside className="ff-navigation-shell">
    <Link to="/dashboard" className="ff-navigation-brand" aria-label="FinFlow overview">
      <img src="/images/finflow-mark.svg" width="36" height="36" alt="" />
      <span>FinFlow</span>
    </Link>
    <nav className="ff-navigation" aria-label="Main navigation">
      {primaryDestinations.map(item => {
        const Icon = icons[item.icon];
        return <Link key={item.path} to={item.path} aria-current={active === item.icon ? 'page' : undefined}>
          <Icon size={22} strokeWidth={1.75} aria-hidden="true" /><span>{item.label}</span>
        </Link>;
      })}
    </nav>
    <a href="/support.html" className="ff-navigation-support"><CircleHelp size={20} aria-hidden="true" />Help & support</a>
  </aside>;
}
